﻿// This binding is designed to be used with `knockout.validation` library only
ko.bindingHandlers.validationContainer = {
    update: function (element, valueAccessor, allBindingsAccessor) {
        var obs = valueAccessor();

        if (obs === null || typeof obs === 'undefined')
            return;

        var isModified = obs.isModified && obs.isModified();
        var isValid    = obs.isValid && obs.isValid() && isModified;
        var isInvalid  = obs.isValid && (obs.isValid() === false) && isModified;

        if (isValid)
            $(element).addClass("has-success");
        else
            $(element).removeClass("has-success");

        if (isInvalid)
            $(element).addClass("has-error");
        else
            $(element).removeClass("has-error");
    }
};